export default "__VITE_ASSET__P8d5z3ww__"